/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useHeader } from 'hooks/useHeader';
import DisplayList from 'components/DisplayList';
import SEO from 'components/SEO';
import { URL_LOGO } from 'constants/logoUrl';
import FacebookTypes from 'constants/facebookTypes';

const CategoriesListPage = () => {
  const { categories } = useHeader();

  return (
    <>
      <SEO
        title="Liste des catégories"
        description="En cliquant vous accédez à la liste des produits d'une catégorie spécifique"
        type={FacebookTypes.article}
        image={URL_LOGO}
      />
      <DisplayList content={categories} toDisplay="des Catégories" />
    </>
  );
};

export default CategoriesListPage;
